import { Option } from '@helvetia/components/forms/NativeSelect/NativeSelect.types'

import { Agency } from '../../../core/domain/agency.model'
import { AgentBroker } from '../../../core/domain/agentBroker.model'
import AgencyService from '../../../core/services/agency.service'
import AgentService from '../../../core/services/agent.service'
import { getUserName } from '../../../core/services/storage.service'
import { LifecyclePresenter } from '../../_components/ConnectComponent'
import { toDropDownList } from '../../_components/DropDownSelect'
import { AdobeEventManager } from '../../_utils/adobeAnalytics'
import { dataLayer } from '../../_utils/adobeAnalytics/adobeAnalytics.conf'
import { AgentBrokerDataForm, SignUpRaw, View } from './SignUp.view'

export class SignUpPresenter implements LifecyclePresenter<View> {
  private view!: SignUpRaw
  private agent: AgentBroker
  private agencyListOptions: Option[] = []

  initialize(view) {
    this.view = view
  }

  onLifecycleStart = async () => {
    await this.getAgentBroker()

    if (AgentService.isAgent()) {
      const agencyList = await AgencyService.getAgencyList()
      this.agencyListOptions = this.mapDropDownList(agencyList)

      dataLayer.page.category.formName = 'agentBroker-portal-signUp'
      dataLayer.page.category.applicationStep = 'portal-agentBroker-signUp'
      AdobeEventManager.emit('portal-signUp_init', 'calc_step')

      let defaultOption = [
        {
          text: this.view.props.t('contactData.agencyNumber.default'),
          value: 0,
        } as Option,
      ]
      this.agencyListOptions = defaultOption.concat(this.agencyListOptions)
    }

    this.view.setInitialValues(
      {
        firstName: this.agent.firstName,
        lastName: this.agent.lastName,
        phone: this.agent.phone,
        email: this.agent.email,
        agentBrokerNumber: this.agent.agentBrokerNumber,
        agencyId: this.agent.agencyId,
      },
      this.agencyListOptions,
    )
  }

  getAgentBroker = async () => {
    try {
      const agentUser = getUserName()
      this.agent = await AgentService.getAgentBroker(agentUser)
    } catch (error) {
      console.log(error)
    }
  }

  mapDropDownList = (list: Agency[]) => {
    return list.map(toDropDownList)
  }

  onContinue = async (formValues: AgentBrokerDataForm) => {
    const agentToUpdate = this.setFormValues(formValues)

    AgentService.saveAgent(agentToUpdate).then(() =>
      this.view.props.history.push('/portal'),
    )
  }

  setFormValues = (formValues: AgentBrokerDataForm) => {
    return Object.assign(this.agent, {
      ...formValues,
      agencyId: Number(formValues.agencyId),
    })
  }
}
